import { FormConnectToObject } from 'app/views/forms/common/FormConnectToObject'
import { PdfPropsForm } from 'app/views/forms/common/PdfPropsForm'
import { useDispatch } from 'react-redux'
import { formComponentTypes } from '../../formComponentTypes'
import { FormMilestoneUpdate } from './FormMilestoneUpdate'
import { Autocomplete, TextField } from '@mui/material'
import { Trans } from '@lingui/macro'
import { useFormEditorContext } from 'app/views/forms/editor/FormEditorContext'

export const FormEditorMilestoneUpdate = ({
  id,
  showPrintProps,
  showPdfProps,
  editMode,
  depth,
  typeProps,
  injectable,
  injectableId,
  ...props
}) => {
  const { availableObjects } = useFormEditorContext()

  const statuses = availableObjects?.find((obj) => obj.name === 'FGM_Base__Benchmark__c')
  ?.fields?.find((field) => field.name === 'FGM_Base__Status__c')
  ?.picklistValues?.filter((status) => status?.active) || []
  
  const statusesOptions = statuses?.map((status) => status.value)

  const dispatch = useDispatch()
  const _typeProps = typeProps || {}
  if (!editMode) {
    return (
      <FormMilestoneUpdate editMode id={id} typeProps={_typeProps} {...props} />
    )
  }

  return (
    <div>
      {showPdfProps && (
        <PdfPropsForm
          typeProps={typeProps}
          dispatch={dispatch}
          injectable={injectable}
          depth={depth}
        />
      )}
      <Autocomplete
        multiple
        options={statusesOptions}
        getOptionLabel={(option) => statuses?.find((status) => status.value === option)?.label}
        value={_typeProps.validStatuses}
        style={{ marginTop: 16, marginBottom: 16 }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={<Trans>FORM_EDITOR_MILESTONE_UPDATE_VALID_STATUSES</Trans>}
            variant="outlined"
          />
        )}
        onChange={(e, value) => {
          const toSet = { ...typeProps }
          toSet.validStatuses = value
          dispatch({
            type: 'FIELD',
            injectable,
            depth: depth.split('.'),
            fieldName: 'typeProps',
            fieldValue: { ...toSet }
          })
        }}
      />
    
      <FormConnectToObject
        injectable={injectable}
        injectableId={injectableId}
        typeProps={_typeProps}
        depth={depth}
        noField
        objectsConnections={
          formComponentTypes.milestoneUpdate.connectsToMultipleObjects
        }
      />
    </div>
  )
}
